import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "data-edit" }
const _hoisted_2 = { class: "form-group" }
const _hoisted_3 = { class: "form-group" }
const _hoisted_4 = {
  key: 0,
  class: "fields-section"
}
const _hoisted_5 = ["onUpdate:modelValue"]
const _hoisted_6 = ["onUpdate:modelValue"]
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "form-group" }
const _hoisted_9 = { class: "form-group" }
const _hoisted_10 = { class: "form-group" }

import { ref, watch } from 'vue'

interface Props {
  block: any
}


export default /*@__PURE__*/_defineComponent({
  __name: 'DataEdit',
  props: {
    block: {}
  },
  emits: ["update"],
  setup(__props: any, { emit: __emit }) {

const props = __props
const emit = __emit

const localBlock = ref(JSON.parse(JSON.stringify(props.block)))

// Inicializar dados se não existirem
if (!localBlock.value.data) {
  localBlock.value.data = {
    title: 'Dados',
    dataKey: 'dados-gerais',
    fields: []
  }
}

if (!localBlock.value.style) {
  localBlock.value.style = {
    backgroundColor: '#f8f9fa',
    padding: '15px',
    border: '1px solid #e9ecef',
    borderRadius: '8px'
  }
}

watch(() => props.block, (newBlock) => {
  localBlock.value = JSON.parse(JSON.stringify(newBlock))
}, { deep: true })

function onChange() {
  emit('update', localBlock.value)
}

function onDataKeyChange() {
  // Carregar campos padrão baseado na chave selecionada
  const fieldsMap: any = {
    'dados-gerais': [
      { label: 'Local', value: '' },
      { label: 'Data', value: '' },
      { label: 'Avaliador', value: '' }
    ],
    'dados-ambiente': [
      { label: 'Temperatura', value: '' },
      { label: 'Umidade', value: '' },
      { label: 'Iluminância', value: '' }
    ],
    'dados-avaliacao': [
      { label: 'Tipo de Avaliação', value: '' },
      { label: 'Método', value: '' },
      { label: 'Equipamento', value: '' }
    ]
  }

  if (localBlock.value.data.dataKey !== 'custom') {
    localBlock.value.data.fields = fieldsMap[localBlock.value.data.dataKey] || []
  }
  
  onChange()
}

function addField() {
  if (!localBlock.value.data.fields) {
    localBlock.value.data.fields = []
  }
  localBlock.value.data.fields.push({ label: '', value: '' })
  onChange()
}

function removeField(index: number) {
  localBlock.value.data.fields.splice(index, 1)
  onChange()
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[14] || (_cache[14] = _createElementVNode("h4", null, "Editar Bloco de Dados", -1)),
    _createElementVNode("div", _hoisted_2, [
      _cache[5] || (_cache[5] = _createElementVNode("label", null, "Título:", -1)),
      _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((localBlock.value.data.title) = $event)),
        onInput: onChange,
        type: "text",
        placeholder: "Título do bloco de dados"
      }, null, 544), [
        [_vModelText, localBlock.value.data.title]
      ])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _cache[7] || (_cache[7] = _createElementVNode("label", null, "Chave dos Dados:", -1)),
      _withDirectives(_createElementVNode("select", {
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((localBlock.value.data.dataKey) = $event)),
        onChange: onDataKeyChange
      }, [...(_cache[6] || (_cache[6] = [
        _createElementVNode("option", { value: "dados-gerais" }, "Dados Gerais", -1),
        _createElementVNode("option", { value: "dados-ambiente" }, "Dados do Ambiente", -1),
        _createElementVNode("option", { value: "dados-avaliacao" }, "Dados da Avaliação", -1),
        _createElementVNode("option", { value: "custom" }, "Personalizado", -1)
      ]))], 544), [
        [_vModelSelect, localBlock.value.data.dataKey]
      ])
    ]),
    (localBlock.value.data.dataKey === 'custom')
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", { class: "section-header" }, [
            _cache[8] || (_cache[8] = _createElementVNode("label", null, "Campos Personalizados:", -1)),
            _createElementVNode("button", {
              onClick: addField,
              type: "button",
              class: "btn-add"
            }, "+")
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(localBlock.value.data.fields, (field, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              class: "field-item"
            }, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": ($event: any) => ((field.label) = $event),
                onInput: onChange,
                placeholder: "Rótulo do campo",
                class: "field-label"
              }, null, 40, _hoisted_5), [
                [_vModelText, field.label]
              ]),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": ($event: any) => ((field.value) = $event),
                onInput: onChange,
                placeholder: "Valor do campo",
                class: "field-value"
              }, null, 40, _hoisted_6), [
                [_vModelText, field.value]
              ]),
              _createElementVNode("button", {
                onClick: ($event: any) => (removeField(index)),
                type: "button",
                class: "btn-remove"
              }, " × ", 8, _hoisted_7)
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_8, [
      _cache[9] || (_cache[9] = _createElementVNode("label", null, "Cor de Fundo:", -1)),
      _withDirectives(_createElementVNode("input", {
        type: "color",
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((localBlock.value.style.backgroundColor) = $event)),
        onChange: onChange
      }, null, 544), [
        [_vModelText, localBlock.value.style.backgroundColor]
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _cache[11] || (_cache[11] = _createElementVNode("label", null, "Padding:", -1)),
      _withDirectives(_createElementVNode("select", {
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((localBlock.value.style.padding) = $event)),
        onChange: onChange
      }, [...(_cache[10] || (_cache[10] = [
        _createElementVNode("option", { value: "10px" }, "Pequeno (10px)", -1),
        _createElementVNode("option", { value: "15px" }, "Normal (15px)", -1),
        _createElementVNode("option", { value: "20px" }, "Grande (20px)", -1),
        _createElementVNode("option", { value: "25px" }, "Muito Grande (25px)", -1)
      ]))], 544), [
        [_vModelSelect, localBlock.value.style.padding]
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _cache[13] || (_cache[13] = _createElementVNode("label", null, "Borda:", -1)),
      _withDirectives(_createElementVNode("select", {
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((localBlock.value.style.border) = $event)),
        onChange: onChange
      }, [...(_cache[12] || (_cache[12] = [
        _createElementVNode("option", { value: "none" }, "Sem Borda", -1),
        _createElementVNode("option", { value: "1px solid #e9ecef" }, "Borda Leve", -1),
        _createElementVNode("option", { value: "2px solid #dee2e6" }, "Borda Média", -1),
        _createElementVNode("option", { value: "3px solid #007bff" }, "Borda Destacada", -1)
      ]))], 544), [
        [_vModelSelect, localBlock.value.style.border]
      ])
    ])
  ]))
}
}

})